module.exports = __webpack_public_path__ + "img/239.66090931.png";